import { formatInTimeZone } from 'date-fns-tz';

export type TaskPriority = 'urgent' | 'high' | 'medium' | 'low';

export function nowIso(): string {
  return new Date().toISOString();
}

export function todayIso(timezone: string): string {
  return formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd');
}

/** Календарная дата ISO-времени в часовом поясе пользователя. */
export function isoDateInTimezone(iso: string, timezone: string): string {
  try {
    return formatInTimeZone(new Date(iso), timezone, 'yyyy-MM-dd');
  } catch {
    return iso.slice(0, 10);
  }
}

export function addDaysIso(dateIso: string, days: number): string {
  const [year, month, day] = dateIso.split('-').map(Number);
  if (year === undefined || month === undefined || day === undefined) {
    return dateIso;
  }
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function isValidCalendarDate(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/u.test(value);
}

export function isValidClockTime(value: string): boolean {
  return /^([01]\d|2[0-3]):[0-5]\d$/u.test(value);
}

export function formatTaskDateLabel(dateIso: string, timezone: string): string {
  try {
    return formatInTimeZone(new Date(`${dateIso}T12:00:00Z`), timezone, 'dd.MM.yyyy');
  } catch {
    return dateIso;
  }
}

export function yesterdayIso(timezone: string): string {
  return addDaysIso(todayIso(timezone), -1);
}

export function tomorrowIso(timezone: string): string {
  return addDaysIso(todayIso(timezone), 1);
}

/** 0 = понедельник … 6 = воскресенье (календарная дата YYYY-MM-DD). */
export function weekdayMon0(dateIso: string): number {
  const [year, month, day] = dateIso.split('-').map(Number);
  if (year === undefined || month === undefined || day === undefined) {
    return 0;
  }
  const jsDay = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return (jsDay + 6) % 7;
}

export function addMonthsCalendar(dateIso: string, months: number): string {
  const [year, month, day] = dateIso.split('-').map(Number);
  if (year === undefined || month === undefined || day === undefined) {
    return dateIso;
  }
  const total = year * 12 + (month - 1) + months;
  const nextYear = Math.floor(total / 12);
  const nextMonth = (total % 12) + 1;
  const daysInNext = new Date(Date.UTC(nextYear, nextMonth, 0)).getUTCDate();
  const nextDay = Math.min(day, daysInNext);
  return `${String(nextYear).padStart(4, '0')}-${String(nextMonth).padStart(2, '0')}-${String(nextDay).padStart(2, '0')}`;
}

export function compareCalendarDates(a: string, b: string): number {
  if (a === b) {
    return 0;
  }
  return a < b ? -1 : 1;
}
